/**
 * The staff-management route path — a single flat screen, so there is one path to name, the same
 * shape as `yubikeys/paths.ts`. Admin only; the gate lives in `App.tsx`, and the real control is
 * the API's `requireRole('admin')`.
 */
export const staffRoutePath = '/staff';
